import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import { Card, CardBody, Col, FormGroup, Input, Row } from "reactstrap";

import { H3, MUIIcons } from "../../AbstractElements";
import {
  ALL_USERS_STATUS,
  courseTypeMap,
  EXTERNAL_TRAINER,
  INTERNAL_TRAINER,
  REPORTING_MANAGER_STATUS,
  TA,
  TM,
} from "../../Api/constants";
import Divider from "../../CommonElements/Divider";
import FilterSliderModal from "../../CommonElements/FilterSliderModal";
import LabelTooltip from "../../CommonElements/LabelTooltip";
import CommonModal from "../../CommonElements/Modal";
import MultiSelectDropdown from "../../CommonElements/MultiSelectDropdown";
import SearchBar from "../../CommonElements/SearchBar";
import StatusDisplay from "../../CommonElements/StatusDisplay";
import UserDetailsCard from "../../container/UserDetailsCard";
import { useAppDispatch, useAppSelector } from "../../ReduxToolkit/Hooks";
import {
  downloadNominationStatus,
  getNominationStatus,
} from "../../ReduxToolkit/Reducers/CourseRequestSlice";
import { reviewTrainerOrNominee } from "../../ReduxToolkit/Reducers/CourseSlice";
import { getLocationList } from "../../ReduxToolkit/Reducers/MasterSlice";
import { getRMList, getUsersList } from "../../ReduxToolkit/Reducers/UserSlice";
import {
  AssistantInstructor,
  CourseSchedule,
  EmployeeDetail,
  Instructor,
  Location,
  ProgramName,
  ReportingManager,
  User,
  Select,
  SideBarTitleNominationStatus,
  Status,
  TypeOfProgram,
  StartDate,
  EndDate,
  RMDetail,
  Locations,
  ApproveNomineeReason,
  RejectNomineeReason,
  Remove,
  Close,
  Confirm,
  RemoveParticipants,
  Reason,
  AddComment,
  Enter,
  Description,
  PleaseSelectReason,
  EmptyCommentsAlert,
  Comment,
  Action,
  SeatsAvailable,
  NominationEndsOn,
  Details,
  LastAction,
  By,
  On,
} from "../../utils/Constant";
import {
  createTooltipCell,
  declineNomineeTMReasons,
  declineNomineeTMReasonsMap,
  formatCustomDate,
  iltViltFilterDropdownList,
  nominationStatusDropValues,
  nomineeDashboardStatusMap,
  showToast,
} from "../../utils/helper/helper";
import {
  getFromLocalStorage,
  LOGGED_IN_USER,
} from "../../utils/helper/localStorageutils";
import useIsMobile from "../../utils/helper/responsive";

import "./style.scss";

const NominationStatus = () => {
  const [userListOptions, setUserListOptions] = useState([]);
  const [rmListOptions, setRmListOptions] = useState([]);
  const [formValues, setFormValues] = useState({
    start_date: new Date(),
    end_date: new Date(new Date().setMonth(new Date().getMonth() + 3)),
    userValues: [],
    rmValues: [],
  });

  const [locationNameMap, setLocationNameMap] = useState([]);
  const [instructorNameMap, setInstructorMap] = useState([]);
  const { locationList } = useAppSelector(state => state.master);
  const [selectedFilterValues, setSelectedFilterValues] = useState({});
  const [defaultFilterValues, setDefaultFilterValues] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedModalType, setSelectedModalType] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [comments, setComments] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const loginData = getFromLocalStorage(LOGGED_IN_USER);

  const { nominationStatus } = useAppSelector(state => state.courseRequest);
  const { usersList, rmList } = useAppSelector(state => state.user);
  const dispatch = useAppDispatch();

  const customStyles = {
    rows: {
      style: {
        padding: "1rem 0",
      },
    },
  };

  const getNominationStatusList = selectedFilter => {
    dispatch(
      getNominationStatus({
        filterValues: {
          ...formValues,
          ...selectedFilter,
        },
      })
    );
  };

  useEffect(() => {
    getNominationStatusList(selectedFilterValues);
  }, [formValues]);

  useEffect(() => {
    const filteredData = getFilteredData(searchValue);
    setFilteredData(filteredData || []);
  }, [nominationStatus]);

  useEffect(() => {
    dispatch(getUsersList({ role: ALL_USERS_STATUS }));
    dispatch(getRMList({ role: REPORTING_MANAGER_STATUS }));
    dispatch(getLocationList());
  }, []);

  useEffect(() => {
    const value = [];
    if (usersList) {
      usersList?.users?.forEach((item: any) => {
        value.push({
          name: item?.id,
          label: `${item?.user_name} - ${item?.employee_code || "-"} - ${item?.email || "-"}`,
          value: `${item?.user_name} - ${item?.employee_code || "-"} - ${item?.email || "-"}`,
        });
      });

      const userMapObj = {};
      const instructorMapObj = [];
      usersList?.users?.forEach(user => {
        if (user?.role?.includes("it") || user?.role?.includes("et")) {
          instructorMapObj.push({
            name: user.id?.toString(),
            value: user?.user_name,
            label: user?.user_name,
          });
        }
        userMapObj[user.id] = user;
      });
      setInstructorMap(instructorMapObj);
    }
    setUserListOptions(value);
  }, [usersList]);

  useEffect(() => {
    const value = [];
    if (rmList) {
      rmList?.users?.forEach((item: any) => {
        value.push({
          name: item?.id,
          label: `${item?.user_name} - ${item?.employee_code || "-"} - ${item?.email || "-"}`,
          value: `${item?.user_name} - ${item?.employee_code || "-"} - ${item?.email || "-"}`,
        });
      });
    }
    setRmListOptions(value);
  }, [rmList]);

  useEffect(() => {
    const locationMapObj = [];
    locationList?.location?.forEach(location => {
      locationMapObj.push({
        name: location?.id?.toString(),
        value: location?.name,
        label: location?.name,
      });
    });
    setLocationNameMap(locationMapObj);
  }, [locationList]);

  const isMobile = useIsMobile();

  const onViewClick = row => {
    setSelectedModalType("view");
    setSelectedRow(row);
    toggleModal();
  };

  const handleApprove = row => {
    setSelectedModalType("approve");
    toggleModal();
    setSelectedRow(row);
  };

  const handleReject = row => {
    setSelectedModalType("reject");
    toggleModal();
    setSelectedRow(row);
  };

  const columns = [
    {
      name: ProgramName,
      selector: row => row.course_name,
      minWidth: "20rem",
      sortable: true,
    },
    {
      name: CourseSchedule,
      selector: row =>
        `${formatCustomDate(row?.course_start_date)} - ${formatCustomDate(row?.course_end_date)}`,
      minWidth: "15rem",
      sortable: true,
      sortFunction: (rowOne, rowTwo) => {
        const parseDate = (dateStr: string | null | undefined) => {
          if (!dateStr) return 0;
          return new Date(dateStr).getTime();
        };
        const firstParsedDate = parseDate(rowOne.course_start_date);
        const secondParsedDate = parseDate(rowTwo.course_start_date);
        return firstParsedDate - secondParsedDate;
      },
    },
    {
      name: EmployeeDetail,
      cell: row => {
        return (
          <UserDetailsCard
            userDetails={{
              id: row.employee_id,
              name: row.user_name,
              empId: row.employee_id || "-",
              mobile: row.user_mobile_number || "-",
            }}
          />
        );
      },
      minWidth: "20rem",
      sortable: true,
      sortFunction: (firstRow, secondRow) => {
        const firstUserName = firstRow.user_name?.toLowerCase();
        const secondUserName = secondRow.user_name?.toLowerCase();
        if (firstUserName < secondUserName) return -1;
        if (firstUserName > secondUserName) return 1;
        return 0;
      },
    },
    {
      name: RMDetail,
      minWidth: "20rem",
      sortable: true,
      sortFunction: (firstRow, secondRow) => {
        const firstUserName = firstRow.rm_name?.toLowerCase();
        const secondUserName = secondRow.rm_name?.toLowerCase();
        if (firstUserName < secondUserName) return -1;
        if (firstUserName > secondUserName) return 1;
        return 0;
      },
      cell: row => {
        return (
          <UserDetailsCard
            userDetails={{
              id: row.rm_employee_id,
              name: row.rm_name || "-",
              empId: row.rm_employee_id || "-",
              mobile: row.rm_mobile_number || "-",
            }}
          />
        );
      },
    },
    {
      name: Location,
      selector: row => row?.location || "-",
      minWidth: "8rem",
      sortable: true,
    },
    {
      name: TypeOfProgram,
      selector: row => courseTypeMap[row.course_type] || "-",
      minWidth: "8rem",
      sortable: true,
    },
    {
      name: Instructor,
      selector: row => row.primary_trainer_name || "-",
      minWidth: "8rem",
      sortable: true,
    },

    {
      name: AssistantInstructor,
      selector: (row: any) => {
        return row.assistant_trainer_names &&
          row.assistant_trainer_names.length > 0
          ? row.assistant_trainer_names.join(", ")
          : "-";
      },
      cell: (row: any) => {
        return createTooltipCell(
          row.assistant_trainer_names.join(", "),
          `assistant-instructor-${row.nomination_id}`
        );
      },
      sortable: true,
      minWidth: "12rem",
    },
    {
      name: SeatsAvailable,
      selector: row => row.available_count || 0,
      minWidth: "8rem",
      sortable: true,
    },

    {
      name: NominationEndsOn,
      selector: row => formatCustomDate(row?.nomination_end_date),
      minWidth: "15rem",
      sortable: true,
      sortFunction: (rowOne, rowTwo) => {
        const parseDate = (dateStr: string | null | undefined) => {
          if (!dateStr) return 0;
          return new Date(dateStr).getTime();
        };
        const firstParsedDate = parseDate(rowOne.nomination_end_date);
        const secondParsedDate = parseDate(rowTwo.nomination_end_date);
        return firstParsedDate - secondParsedDate;
      },
    },

    {
      name: Status,
      center: true,
      minWidth: "10rem",
      sortable: true,
      cell: row => {
        const statusLabel = nomineeDashboardStatusMap[row?.nomination_status];
        return (
          <div className="d-flex align-items-center gap-1">
            <span>{statusLabel}</span>
            <MUIIcons
              iconName="InfoOutlined"
              className="primary-icon-color pointer"
              size={18}
              onClick={() => onViewClick(row)}
            />
          </div>
        );
      },
    },
    {
      name: Action,
      center: true,
      minWidth: "8rem",
      cell: row => {
        const statusLabel = row?.nomination_status;
        const isNominated = statusLabel === "nominated";

        const userRole = loginData?.currentRole;
        const userId = loginData?.id;

        const isTMorTA = userRole === TM || userRole === TA;
        const isTrainerAuthorized =
          [EXTERNAL_TRAINER, INTERNAL_TRAINER].includes(userRole) &&
          (row?.primary_trainer_id === userId ||
            row?.replaced_trainer_ids?.includes(userId));

        const showActions = isNominated && (isTMorTA || isTrainerAuthorized);

        if (!showActions) return "-";

        return (
          <div className="d-flex align-items-center gap-2">
            <MUIIcons
              iconName="CheckCircleOutline"
              className="text-success pointer"
              size={20}
              onClick={() => handleApprove(row)}
            />
            <MUIIcons
              iconName="CancelOutlined"
              className="primary-icon-color pointer"
              size={20}
              onClick={() => handleReject(row)}
            />
          </div>
        );
      },
    },
  ];

  const handleMultiSelectChange = (id, values) => {
    setFormValues(prevState => ({
      ...prevState,
      [id]: values,
    }));
  };

  const handleDateChange = (field, date) => {
    if (!date) return;

    const { start_date, end_date } = formValues;

    let newStartDate = start_date;
    let newEndDate = end_date;

    if (field === "start_date") {
      newStartDate = date;
    } else if (field === "end_date") {
      newEndDate = date;
    }

    setFormValues(prevState => ({
      ...prevState,
      start_date: newStartDate,
      end_date: newEndDate,
    }));
  };

  const handleDone = values => {
    getNominationStatusList(values);
  };

  const handleClear = () => {
    setSelectedFilterValues({});
    setDefaultFilterValues({});
    getNominationStatusList({});
  };

  let sizeTitle = "";
  if (selectedModalType === "approve") {
    sizeTitle = ApproveNomineeReason;
  } else if (selectedModalType === "reject") {
    sizeTitle = RejectNomineeReason;
  } else if (selectedModalType === "remove") {
    sizeTitle = Remove;
  } else if (selectedModalType === "view") {
    sizeTitle = Details;
  }

  const toggleModal = () => {
    if (isModalOpen) {
      setSelectedModalType("");
      setSelectedReason("");
      setComments("");
      setSelectedRow(null);
    }
    setIsModalOpen(!isModalOpen);
  };

  const getDownloadURL = () => {
    const filterValues = {
      ...formValues,
      ...selectedFilterValues,
      download: true,
    };
    dispatch(
      downloadNominationStatus({
        filterValues,
      })
    );
  };

  const renderModalBody = type => {
    return (
      <>
        {type === "remove" && RemoveParticipants}
        {type === "view" && (
          <>
            <StatusDisplay
              label={LastAction}
              number={nomineeDashboardStatusMap[selectedRow?.nomination_status]}
            />
            <div className="mt-2"></div>
            <StatusDisplay
              label={`${LastAction}  ${By}`}
              number={[
                selectedRow?.last_action_by_name,
                selectedRow?.last_action_by_employee_id &&
                  `(${selectedRow.last_action_by_employee_id})`,
              ]
                .filter(Boolean)
                .join(" ")}
            />
            <div className="mt-2"></div>
            <StatusDisplay
              label={`${LastAction}  ${On}`}
              number={formatCustomDate(selectedRow?.last_action_on)}
            />
            <div className="mt-2"></div>
            <StatusDisplay
              label={Reason}
              number={declineNomineeTMReasonsMap[selectedRow?.reason]}
            />
            <div className="mt-2"></div>
            <StatusDisplay label={Comment} number={selectedRow?.other_reason} />
          </>
        )}
        {type === "reject" && (
          <>
            <LabelTooltip
              label={Reason}
              tooltipText={`${Select} ${Reason}`}
              important
            />
            <Input
              type="select"
              id="reason-dropdown"
              className="mb-2"
              value={selectedReason}
              onChange={e => {
                setSelectedReason(e.target.value);
              }}
            >
              <option value="" disabled>
                {`${Select} ${Reason}`}
              </option>
              {declineNomineeTMReasons?.map(reason => (
                <option key={reason.value} value={reason.value}>
                  {reason.label}
                </option>
              ))}
            </Input>
          </>
        )}
        {type !== "remove" && type !== "view" && (
          <FormGroup>
            <LabelTooltip
              label={AddComment}
              tooltipText={`${Enter} ${Description}`}
              important
            />
            <Input
              onChange={e => {
                if (
                  (e.target.value && e.target.value.length <= 255) ||
                  e.target.value === ""
                ) {
                  setComments(e.target.value);
                }
              }}
              rows={4}
              name="objective"
              type="textarea"
              placeholder={`${Enter} ${Description}`}
              maxLength={255}
            />
          </FormGroup>
        )}
      </>
    );
  };

  const handlePrimaryBtnClick = async () => {
    if (selectedModalType === "view") {
      toggleModal();
      return;
    }

    if (selectedModalType === "reject" && selectedReason === "") {
      showToast(PleaseSelectReason, "error");
      return;
    }
    if (selectedModalType === "approve" || selectedModalType === "reject") {
      if (!comments || comments.trim() === "") {
        showToast(EmptyCommentsAlert, "error");
        return;
      }
    }

    const payload = {
      action: selectedModalType === "approve" ? "approved" : "rejected",
      type: "nominee",
      id: selectedRow.nomination_id,
      other_reason: comments,
    };

    if (selectedModalType === "reject") {
      payload["reason"] = selectedReason;
    }

    await dispatch(reviewTrainerOrNominee({ review: payload }));
    getNominationStatusList(selectedFilterValues);
    toggleModal();
  };

  const handleSearch = (query: string) => {
    const filteredData = getFilteredData(query);

    setFilteredData(filteredData || []);
    setSearchValue(query);
  };

  const getFilteredData = query => {
    const data =
      nominationStatus && nominationStatus["nominations"]
        ? nominationStatus["nominations"]
        : [];

    const filteredAssessment = data?.filter(assessment =>
      assessment.course_name.toLowerCase().includes(query.toLowerCase())
    );

    return filteredAssessment;
  };

  return (
    <div className="page-body page-body-margin nomination-status">
      <CommonModal
        sizeTitle={sizeTitle}
        modalBodyClassName=""
        isOpen={isModalOpen}
        toggle={toggleModal}
        backdrop="static"
        size="lg"
        showFooter
        onPrimaryBtnClick={handlePrimaryBtnClick}
        primaryBtnText={selectedModalType === "view" ? Close : Confirm}
      >
        {renderModalBody(selectedModalType)}
      </CommonModal>

      <Card className="p-2 mt-2">
        <CardBody>
          <div className="d-flex justify-content-between align-items-md-center container-name">
            <H3>{SideBarTitleNominationStatus}</H3>
            <div className="d-flex gap-2 align-items-center controls-container-name">
              <SearchBar showSearch onSearch={handleSearch} />
              <div>
                <FilterSliderModal
                  dropdowns={[
                    {
                      label: TypeOfProgram,
                      key: "program_type",
                      tooltipText: `${Select} ${TypeOfProgram}`,
                      options: iltViltFilterDropdownList,
                      isMultiSelect: true,
                    },
                    {
                      label: Locations,
                      key: "location",
                      tooltipText: `${Select} ${Locations}`,
                      options: locationNameMap,
                      isMultiSelect: true,
                    },
                    {
                      label: Instructor,
                      key: "instructor",
                      tooltipText: `${Select} ${Instructor}`,
                      options: instructorNameMap,
                      isMultiSelect: true,
                    },
                    {
                      label: Status,
                      key: "status",
                      tooltipText: `${Select} ${Status}`,
                      options: nominationStatusDropValues,
                      isMultiSelect: true,
                    },
                  ]}
                  selectedFilterValues={selectedFilterValues}
                  defaultFilterValues={defaultFilterValues}
                  setSelectedFilterValues={setSelectedFilterValues}
                  setDefaultFilterValues={setDefaultFilterValues}
                  onDone={handleDone}
                  onClear={handleClear}
                />
              </div>
              <MUIIcons
                className="primary-icon-color pointer mb-1"
                onClick={() => getDownloadURL()}
                size={24}
                iconName="FileDownloadOutlined"
              />
            </div>
          </div>
          <Divider />
          <Row>
            <Col
              xs={isMobile && "12"}
              className={isMobile && "col-xs-12 col-sm-6 col-md-6"}
            >
              <FormGroup
                className={
                  formValues?.rmValues?.length
                    ? "nomination-status__disabled"
                    : ""
                }
              >
                <LabelTooltip
                  label={User}
                  tooltipText={User}
                  important={false}
                />
                <MultiSelectDropdown
                  onChange={values =>
                    handleMultiSelectChange("userValues", values)
                  }
                  options={userListOptions}
                  placeholder={`${Select} ${User}`}
                  defaultSelected={userListOptions.filter(opt =>
                    formValues?.userValues?.some((sel: any) => sel === opt.name)
                  )}
                  disabled={!!formValues?.rmValues?.length}
                />
              </FormGroup>
            </Col>

            <Col
              xs={isMobile && "12"}
              className={isMobile && "col-xs-12 col-sm-6 col-md-6"}
            >
              <FormGroup
                className={
                  formValues?.userValues?.length
                    ? "nomination-status__disabled"
                    : ""
                }
              >
                <LabelTooltip
                  label={ReportingManager}
                  tooltipText={ReportingManager}
                  important={false}
                />
                <MultiSelectDropdown
                  onChange={values =>
                    handleMultiSelectChange("rmValues", values)
                  }
                  options={rmListOptions}
                  placeholder={`${Select} ${ReportingManager}`}
                  defaultSelected={rmListOptions.filter(opt =>
                    formValues?.rmValues?.some((sel: any) => sel === opt.name)
                  )}
                  disabled={!!formValues?.userValues?.length}
                />
              </FormGroup>
            </Col>

            <Col
              xs={isMobile && "12"}
              className={isMobile && "col-xs-12 col-sm-6 col-md-6"}
            >
              <LabelTooltip
                label={StartDate}
                tooltipText={StartDate}
                important={false}
                placement={"bottom"}
              />
              <div>
                <DatePicker
                  selected={formValues?.start_date}
                  onChange={(date: Date | null) =>
                    handleDateChange("start_date", date)
                  }
                  placeholderText={`${Select} ${StartDate}`}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                  disabledKeyboardNavigation={true}
                  onKeyDown={e => e.preventDefault()}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </Col>

            <Col
              xs={isMobile && "12"}
              className={isMobile && "col-xs-12 col-sm-6 col-md-6"}
            >
              <LabelTooltip
                label={EndDate}
                tooltipText={EndDate}
                important={false}
                placement={"bottom"}
              />
              <div>
                <DatePicker
                  selected={formValues?.end_date}
                  onChange={(date: Date | null) =>
                    handleDateChange("end_date", date)
                  }
                  minDate={formValues?.start_date}
                  placeholderText={`${Select} ${EndDate}`}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                  disabledKeyboardNavigation={true}
                  onKeyDown={e => e.preventDefault()}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </Col>
          </Row>
          <div className="mt-2">
            <DataTable
              className="nomination-status__table"
              columns={columns}
              data={filteredData}
              customStyles={customStyles}
              pagination
              fixedHeader
              striped
            />
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default NominationStatus;
